import { omit } from "lodash";

const change = ({ data, group, field, value }) => {
  data[group][field] = value
  return data
}

const addAll = ({ data, group, fields }) => {
  const groupData = data[group] || {}
  Object.entries(fields).map(([key, field]) => {
    groupData[key] = groupData[key] || field.defaultValue
  })
  data[group] = groupData
  return data
}

const removeAll = ({ data, group }) => omit(data, [group])

const add = ({ data, group, field, value }) => {
  const groupData = data[group] || {}
  groupData[field] = value
  data[group] = groupData
  return data
}

const remove = ({ data, group, field }) => {
  const groupData = data[group] || {}
  data[group] = omit(groupData, [field])
  if (!Object.keys(data[group]).length) {
    data = omit(data, [group])
  }
  return data
}

export const ACTION = {
  CHANGE: "change",
  ADD_ALL: "add-all",
  REMOVE_ALL: "remove-all",
  ADD: "add",
  REMOVE: "remove",
}

export const PARSE = {
  change,
  addAll,
  removeAll,
  add,
  remove,
}
